import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  "code": 200,
  "data": {
    "series": [
      [
        "2026-03-03",
        {
          "serviceExperience": 90,
          "networkPerformance": 100,
          "securityCompliance": 60,
          "deviceHealth": 55,
          "linkIntegrity": 22
        }
      ],
      [
        "2026-03-04",
        {
          "serviceExperience": 90,
          "networkPerformance": 83,
          "securityCompliance": 70,
          "deviceHealth": 100,
          "linkIntegrity": 11
        }
      ],
      [
        "2026-03-05",
        {
          "serviceExperience": 95,
          "networkPerformance": 73,
          "securityCompliance": 83,
          "deviceHealth": 90,
          "linkIntegrity": 60
        }
      ],
      [
        "2026-03-06",
        {
          "serviceExperience": 99,
          "networkPerformance": 63,
          "securityCompliance": 88,
          "deviceHealth": 95,
          "linkIntegrity": 100
        }
      ],
      [
        "2026-03-07",
        {
          "serviceExperience": 98,
          "networkPerformance": 53,
          "securityCompliance": 95,
          "deviceHealth": 92,
          "linkIntegrity": 33
        }
      ],
      [
        "2026-03-08",
        {
          "serviceExperience": 90,
          "networkPerformance": 83,
          "securityCompliance": 87,
          "deviceHealth": 100,
          "linkIntegrity": 44
        }
      ],
      [
        "2026-03-09",
        {
          "serviceExperience": 95,
          "networkPerformance": 80,
          "securityCompliance": 83,
          "deviceHealth": 100,
          "linkIntegrity": 55
        }
      ]
    ]
  }
}

export const overviewSlice = createSlice({
  name: "ainsightOverview",
  initialState,
});

export default overviewSlice.reducer;
